import Script from 'next/script'

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID

export function GoogleAnalytics() {
  if (!GA_MEASUREMENT_ID) return null

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}', {
            page_path: window.location.pathname,
            send_page_view: true
          });
        `}
      </Script>
    </>
  )
}

export function trackEvent(
  action: string,
  params?: Record<string, unknown>
) {
  if (typeof window === 'undefined' || !(window as any).gtag) return
  ;(window as any).gtag('event', action, params)
}

export function trackPurchase(params: {
  transaction_id: string
  value: number
  currency?: string
  items?: Array<{ item_id: string; item_name: string; quantity: number; price: number }>
}) {
  trackEvent('purchase', params)
}

export function trackSignUp(method?: string) {
  trackEvent('sign_up', { method: method || 'email' })
}

export function trackLogin(method?: string) {
  trackEvent('login', { method: method || 'credentials' })
}
